<template>
  <div class="report-cover">
    <div class="image-box" :class="{'loaded': coverLoaded}">
      <img :src="imgPath" :alt="headline" @load="coverLoaded = true" ref="image">
      <span class="overlay" ref="imageOverlay"></span>
    </div>
    <h1 ref="headline" v-html="headline"></h1>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "ReportCover",
  data() {
    return {
      coverLoaded: false,
      progressOpacity: 1,
      imgPath: require('../assets/images/report/' + this.image),
    }
  },
  props: {
    image: String,
    headline: String
  },
  watch: {
    progressOpacity() {
      this.$emit('cover-change', {progressOpacity: this.progressOpacity});
    }
  },
  emits: ['cover-change'],
  mounted() {
    const t = this;
    const imageOverlay = this.$refs.imageOverlay;
    const headline = this.$refs.headline;

    gsap.to(imageOverlay,{
      opacity: 1,
      scrollTrigger: {
        trigger: imageOverlay,
        scrub: 0.2,
        scroller: '.content-wrapper',
        start: 'top 0',
        onUpdate: function (e) {
          const val = Math.round(e.progress * 100) / 100;
          headline.style.opacity = (1 - val).toString();
          t.progressOpacity = val > 0.5 ? Math.round((2 - val * 2) * 100) / 100 : 1;
        }
      }
    });
  }
}
</script>

<style scoped>
  .report-cover {
    position: sticky;
    background: linear-gradient(100deg, #B1D995 1.4%, #3ABABA 90.79%);
    height: calc(250px + 30vw);
    top: calc(-146px + -30vw);
    z-index: 2;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .image-box, .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .overlay {
    background-color: #102D61;
    opacity: 0;
    z-index: 1;
  }
  .image-box:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    top: 30%;
    right: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
    opacity: 0.5;
  }
  img {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    object-fit: cover;
    transition: opacity 0.4s ease-out;
  }
  .loaded img {
    position: relative;
    display: block;
    opacity: 1;
  }
  h1 {
    position: relative;
    display: block;
    font-size: 100px;
    line-height: 1;
    font-weight: 700;
    text-align: center;
    margin: 0.6em 0.2em;
    padding-bottom: 0.2em;
    z-index: 1;
    background: linear-gradient(100deg, #B1D995 1.4%, #3ABABA 90.79%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media(max-width: 1199px), (max-height: 799px) {
    .report-cover {
      top: calc(-172px - 30vw);
    }
  }
  @media(max-width: 999px) {
    .report-cover {
      height: 70vw;
      top: calc(84px - 70vw);
    }
    h1 {
      font-size: 70px;
    }
  }
  @media(max-width: 767px) {
    .report-cover {
      height: 100vw;
      top: calc(64px - 100vw);
    }
  }
  @media(max-width: 567px) {
    h1 {
      font-size: 11vw;
    }
  }
</style>